
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Technology', href: '/technology' },
    { name: 'Contact', href: '/contact' }
  ];

  const isActive = (href: string) => location.pathname === href;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-gray-800">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/8e9a1ee4738e2b22ec8494c6d9c2fbed/a045d5dcb790742516952289b55d3437.png" 
              alt="Vyoamyug" 
              className="h-10 w-auto object-contain hover:scale-105 transition-transform duration-300"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="/" className="text-gray-300 hover:text-white transition-colors">Home</a>
            <a href="/technology" className="text-gray-300 hover:text-white transition-colors">Technology</a>
            <a href="/partners" className="text-gray-300 hover:text-white transition-colors">Partners</a>
            <a href="/careers" className="text-gray-300 hover:text-white transition-colors">Careers</a>
            <a href="/about" className="text-gray-300 hover:text-white transition-colors">About</a>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <Link to="/contact">
              <Button variant="primary" size="sm" className="whitespace-nowrap">
                <i className="ri-mail-line mr-2"></i>
                Contact
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white p-2"
          >
            <i className={`text-xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-800">
            <nav className="flex flex-col space-y-4">
              <a href="/" className="block py-2 text-gray-300 hover:text-white transition-colors">Home</a>
              <a href="/technology" className="block py-2 text-gray-300 hover:text-white transition-colors">Technology</a>
              <a href="/partners" className="block py-2 text-gray-300 hover:text-white transition-colors">Partners</a>
              <a href="/careers" className="block py-2 text-gray-300 hover:text-white transition-colors">Careers</a>
              <a href="/about" className="block py-2 text-gray-300 hover:text-white transition-colors">About</a>
              <a href="/contact" className="block py-2 text-gray-300 hover:text-white transition-colors">Contact</a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
